module.exports = __webpack_public_path__ + "img/merci logo verRuta.f59eb1d0.svg";